<script>
  import {M} from "../../../external";
  export let data = {};
  export let onRemove;
  export let onClick;

  let icon = "error_outline";
  let message = M.ERROR;

  $: {
    if (!icon || !data || !data.type) {
      icon = "error_outline";
      message = M.ERROR;
    }

    switch (data.type) {
      case "LIST_ADD":
        icon = "person_add";
        message = M.LIST_ADD_GOAL;
        break;
      case "LIST_REMOVE":
        icon = "person_remove";
        message = M.LIST_REMOVE_GOAL;
        break;
      case "MEMBER_GROUP_ADD":
        icon = "person_add";
        message = M.MEMBER_GROUP_ADD_GOAL;
        break;
      case "MEMBER_GROUP_REMOVE":
        icon = "person_remove";
        message = M.MEMBER_GROUP_REMOVE_GOAL;
        break;
      case "EMAIL_OPEN":
        icon = "drafts";
        message = M.EMAIL_OPEN_GOAL;
        break;
      case "EMAIL_CLICK":
        icon = "insert_link";
        message = M.EMAIL_CLICK_GOAL;
        break;
      case "PAGE_VISIT":
        icon = "visibility";
        message = M.PAGE_VISIT_GOAL;
        break;
      case "TAG_ADD":
        icon = "label";
        message = M.TAG_ADD_GOAL;
        break;
      case "TAG_REMOVE":
        icon = "label_off";
        message = M.TAG_REMOVE_GOAL;
        break;
      case "PROPERTY_CHANGE":
        icon = "assignment_ind";
        message = M.PROPERTY_CHANGE_GOAL;
        break;
      case "PURCHASE_MAKE":
        icon = "shopping_basket";
        message = M.PURCHASE_MAKE_GOAL;
        break;
      case "ABANDONED_CART_RECOVER":
        icon = "shopping_cart";
        message = M.CHECK_ABANDONED_CART_RECOVER_GOAL;
        break;
      case "VIDEO_STARTED":
        icon = "play_circle";
        message = M.VIDEO_STARTED;
        break;
      case "VIDEO_COMPLETED":
        icon = "play_circle";
        message = M.VIDEO_COMPLETED_AUT;
        break;
        /*
      case "CIRCLE_ENROLL":
        icon = "add_reaction";
        message = "Enrolled to circle";
        break;
      case "CIRCLE_CONTENT_COMPLETED":
        icon = "add_reaction";
        message = "Completed content in a circle";
        break;*/
      default:
        icon = "error_outline";
        message = M.ERROR;
        break;
    }
  }
</script>

<li>
  <div id={data.name} class="add-automation-rule flex align-center">
    <span class="material-icons-outlined circle-automation-icon orange-border"> {icon} </span>
    <div class="flex-1" on:click={onClick}>
      {#if data.name}
        <span class="col20 f-left light-gray-text t-left mb-5">{message}</span>
        <h5>{data.name}</h5>
      {:else}
        <h5>{message}</h5>
      {/if}
    </div>
    {#if data.type !== "ABANDONED_CART_RECOVER"}
      <a on:click={onClick} class="mr-5"><span class="material-icons-outlined"> settings </span></a>
    {/if}
    <a on:click={onRemove} class="mr-5"><span class="material-icons-outlined"> delete </span></a>
  </div>
</li>
